import { RECOVERY_PATH } from "../../data/content";
import { motion } from "framer-motion";

// Hoisted static objects — one reference reused across every step
const STEP_INITIAL = { opacity: 0, y: 20 };
const STEP_IN_VIEW = { opacity: 1, y: 0 };
const STEP_VIEWPORT = { once: true, margin: "-80px" };

export default function RecoveryPath() {
  return (
    <section className="container-wide py-20">
      <div className="max-w-2xl">
        <div className="eyebrow mb-3">The Physio Hyve Recovery Path™</div>
        <h2 className="text-3xl md:text-5xl font-heading text-brand-ink leading-[1.05]">
          A clear path from where you are, to where you want to be.
        </h2>
        <p className="text-brand-ink2 mt-4">
          Every patient is different. But every good rehabilitation follows a rhythm — one that respects your condition, your goals and your response to care.
        </p>
      </div>

      <div className="mt-14 relative">
        <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-[2px] bg-brand-olive/15 -translate-x-1/2" aria-hidden />
        <div className="space-y-10">
          {RECOVERY_PATH.map((step, idx) => (
            <motion.div
              key={step.step}
              initial={STEP_INITIAL}
              whileInView={STEP_IN_VIEW}
              transition={{ duration: 0.5, delay: idx * 0.05 }}
              viewport={STEP_VIEWPORT}
              className={`relative pl-14 md:pl-0 md:grid md:grid-cols-2 md:gap-16 ${idx % 2 === 0 ? "" : "md:[&>*:first-child]:col-start-2"}`}
            >
              <div className={`md:${idx % 2 === 0 ? "text-right md:pr-16" : "md:pl-16"}`}>
                <div className={`inline-flex flex-col ${idx % 2 === 0 ? "md:items-end" : ""}`}>
                  <span className="font-heading text-brand-terracotta font-medium">STEP {String(step.step).padStart(2, "0")}</span>
                  <h3 className="text-2xl md:text-3xl font-heading text-brand-ink mt-1">{step.title}</h3>
                  <p className="text-brand-ink2 mt-2 max-w-md">{step.body}</p>
                </div>
              </div>
              <div className="hidden md:block" />
              <div className="absolute left-4 md:left-1/2 top-1 -translate-x-1/2">
                <div className="w-4 h-4 rounded-full bg-brand-olive ring-4 ring-brand-bg" />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
